(function () {
  function initVariantGating() {
    const form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    const addBtn = form.querySelector('[name="add"], [type="submit"]');
    if (!addBtn) return;

    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    const fieldsets = variantSelects.querySelectorAll('fieldset.product-form__input');
    if (fieldsets.length === 0) return;

    const userSelected = new Set();

    fieldsets.forEach((fieldset, index) => {
      fieldset.addEventListener('change', () => {
        userSelected.add(index);
        updateButtonState();
      });
    });

    function updateButtonState() {
      const allTouched = [...fieldsets].every((_, i) => userSelected.has(i));
      addBtn.disabled = !allTouched;
      addBtn.style.opacity = allTouched ? '1' : '0.4';
      addBtn.style.cursor = allTouched ? 'pointer' : 'not-allowed';
      addBtn.title = allTouched ? '' : 'Por favor selecciona todas las opciones';
    }

    updateButtonState();
  }

  // Intenta cada 100ms hasta que el DOM esté listo (máx 5 segundos)
  function waitAndInit() {
    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      const variantSelects = document.querySelector('variant-selects');
      const form = document.querySelector('form[action="/cart/add"]');
      if (variantSelects && form) {
        clearInterval(interval);
        initVariantGating();
      }
      if (attempts > 50) clearInterval(interval);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitAndInit);
  } else {
    waitAndInit();
  }

  document.addEventListener('shopify:section:load', waitAndInit);
})();


